import React from "react";
import { useTranslation } from "react-i18next";

export const FinancialSummarySearch = ({
  firstName,
  handleFirstNameChange,
  lastName,
  handleLastNameChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-4 flex flex-col sm:flex-row justify-between items-start sm:items-center">
      <a
        href="https://xlsx.ponzilover.com/mv_user_financial_summary.xlsx"
        className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded mb-4 sm:mb-0"
      >
        {t('download')} Financial summary.xlsx
      </a>
      <div className="flex flex-col sm:flex-row items-start sm:items-center">
        <span className="text-gray-700 font-semibold mb-2 sm:mb-0 sm:mr-3">{t("search")}:</span>
        <input
          type="text"
          placeholder={t("search_first_name")}
          className="px-4 py-2 mb-2 sm:mb-0 sm:mr-3 border rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={firstName}
          onChange={handleFirstNameChange}
        />
        <input
          type="text"
          placeholder={t("search_last_name")}
          className="px-4 py-2 border rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={lastName}
          onChange={handleLastNameChange}
        />
      </div>
    </div>
  );
};
